import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth.service';
import { RoutingService } from 'src/app/core/services/routing.service';
import { Notify } from 'notiflix';
import { SocketService } from 'src/app/core/services/socket.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  @ViewChild('bgVideo') bgVideo?: ElementRef<HTMLVideoElement>;
  @ViewChild('loginCard') loginCard?: ElementRef<HTMLDivElement>;
  @ViewChild('colorBackground') colorBackground?: ElementRef<HTMLDivElement>;
  @ViewChild('loginBtn') loginBtn?: ElementRef<HTMLButtonElement>;
  @ViewChild('loginAudio') loginAudio?: ElementRef<HTMLAudioElement>;

  public loginForm: UntypedFormGroup;
  public submitted = false;
  public psvisible: boolean = false;
  private wasLightMode: boolean = false;
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _auths: AuthService,
    private _rs: RoutingService,
    private _ss: SocketService
  ) {
    if (this._auths.token) {
      this._rs.home();
    }

    this.loginForm = this._formBuilder.group({
      identifier: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(100)]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(30)]],
    });
  }

  public ngOnInit(): void {
    console.log("Login Component Initialized - Checking Media & CSS");
    if (document.body.classList.contains('light-mode')) {
        this.wasLightMode = true;
        document.body.classList.remove('light-mode');
    }
    document.body.classList.add('login-v2-theme');
    
    // Inject required CSS for this layout
    const head = document.getElementsByTagName('head')[0];
    
    const link1 = document.createElement('link');
    link1.id = 'login-css-1';
    link1.rel = 'stylesheet';
    link1.href = '/assets/css/main.min.css';
    head.appendChild(link1);
    
    const link2 = document.createElement('link');
    link2.id = 'login-css-2';
    link2.rel = 'stylesheet';
    link2.href = '/assets/css/login-style.css';
    head.appendChild(link2);


  }

  public ngOnDestroy(): void {
    document.body.classList.remove('login-v2-theme');
    if (this.wasLightMode) {
        document.body.classList.add('light-mode');
    }
    
    // Remove injected CSS
    document.getElementById('login-css-1')?.remove();
    document.getElementById('login-css-2')?.remove();


  }



  get f() { return this.loginForm.controls; }

  public onSubmit(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      Notify.warning('Please enter valid login details.');
      return;
    }

    this.submitted = true;

    const videoEl = this.bgVideo?.nativeElement;
    const cardEl = this.loginCard?.nativeElement;
    const colorBgEl = this.colorBackground?.nativeElement;
    const btnEl = this.loginBtn?.nativeElement;
    const audioEl = this.loginAudio?.nativeElement;

    // 1. Play the video and audio immediately to satisfy browser user-gesture requirements
    // This MUST be done synchronously before the async login call.
    if (videoEl) videoEl.play().catch(e => console.error("Video playback failed", e));
    if (audioEl) audioEl.play().catch(e => console.error("Audio playback failed", e));

    this._auths.login(this.loginForm.value).subscribe((success) => {
      if (!success) {
        // Error already notified in AuthService; pause video since login failed.
        this.submitted = false;
        if (videoEl) videoEl.pause();
        return;
      }

      Notify.success('Successfully logged in!');
      this._ss.emitAuth(this._auths.token);

      if (btnEl && cardEl && colorBgEl && videoEl) {
        btnEl.disabled = true;

        // 1. Start the animation transition properties
        cardEl.classList.add('login-card-animating');

        // 2. Trigger the shrink
        setTimeout(() => {
          cardEl.classList.add('login-card-hidden');
          colorBgEl.classList.add('auth-color-hidden');

          // 3. Wait for the 0.8s (800ms) shrink transition to finish
          setTimeout(() => {
              // Hide completely
              cardEl.classList.add('d-none');
              colorBgEl.classList.add('d-none');
              
              // If video playback was blocked or paused, fallback to navigate immediately
              if (videoEl.paused) {
                 this._rs.home();
              } else {
                  // Don't wait for long media playback; route after a short success transition.
                 setTimeout(() => {
                    this._rs.home();
                  }, 1500);
              }
          }, 800);

        }, 100);
      } else {
        this._rs.home();
      }
    });
  }

  public togglePasswordVisibility() {
    this.psvisible = !this.psvisible;
  }
}

